import * as lodash from 'lodash'
import * as moment from 'moment'
import { isUUIDLose } from '@tokeet-frontend/tv3-platform'
import { ChannelNameTokens } from '@tokeet-frontend/tv3-platform'

export function isImportedFromABBV2(item: { inquiryId: string; attributes: any }) {
  return item?.attributes?.api === ChannelNameTokens.AirBnBV2API && !isUUIDLose(item?.inquiryId)
}

export function isChannelCancelable(source: string) {
  const names = [ChannelNameTokens.RentalsUnited, ChannelNameTokens.Holidu]
  source = lodash.toLower(source)
  return !!names.find((n: string) => n.includes(source) || source.includes(n))
}

export function isVrboBooking(item: { inquirySource: string }) {
  const source = lodash.toLower(item?.inquirySource || '')
  return source.includes('vrbo') || source.includes('homeaway')
}

export function isActiveVrboBooking(item: {
  inquirySource: string
  booked: number
  canceled: number
  guestDepart: number
}) {
  return (
    isVrboBooking(item) && !!item?.booked && !item?.canceled && item?.guestDepart > moment.utc().startOf('day').unix()
  )
}
